// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: sdk.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "taf";
export var Sdk_AudioFormat;
(function (Sdk_AudioFormat) {
    Sdk_AudioFormat[Sdk_AudioFormat["STEREO"] = 0] = "STEREO";
    Sdk_AudioFormat[Sdk_AudioFormat["DOLBY"] = 1] = "DOLBY";
    Sdk_AudioFormat[Sdk_AudioFormat["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Sdk_AudioFormat || (Sdk_AudioFormat = {}));
export function sdk_AudioFormatFromJSON(object) {
    switch (object) {
        case 0:
        case "STEREO":
            return Sdk_AudioFormat.STEREO;
        case 1:
        case "DOLBY":
            return Sdk_AudioFormat.DOLBY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Sdk_AudioFormat.UNRECOGNIZED;
    }
}
export function sdk_AudioFormatToJSON(object) {
    switch (object) {
        case Sdk_AudioFormat.STEREO:
            return "STEREO";
        case Sdk_AudioFormat.DOLBY:
            return "DOLBY";
        case Sdk_AudioFormat.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var Sdk_AssetType;
(function (Sdk_AssetType) {
    Sdk_AssetType[Sdk_AssetType["LIVE"] = 0] = "LIVE";
    Sdk_AssetType[Sdk_AssetType["VOD"] = 1] = "VOD";
    Sdk_AssetType[Sdk_AssetType["REPLAY"] = 2] = "REPLAY";
    Sdk_AssetType[Sdk_AssetType["RECORDING"] = 3] = "RECORDING";
    Sdk_AssetType[Sdk_AssetType["REGISTERED_TIMESHIFT"] = 4] = "REGISTERED_TIMESHIFT";
    Sdk_AssetType[Sdk_AssetType["URL"] = 5] = "URL";
    /** VOD_TRAILER - TODO: Missing rakuten, but rakuten should be a part of zapi */
    Sdk_AssetType[Sdk_AssetType["VOD_TRAILER"] = 6] = "VOD_TRAILER";
    Sdk_AssetType[Sdk_AssetType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Sdk_AssetType || (Sdk_AssetType = {}));
export function sdk_AssetTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "LIVE":
            return Sdk_AssetType.LIVE;
        case 1:
        case "VOD":
            return Sdk_AssetType.VOD;
        case 2:
        case "REPLAY":
            return Sdk_AssetType.REPLAY;
        case 3:
        case "RECORDING":
            return Sdk_AssetType.RECORDING;
        case 4:
        case "REGISTERED_TIMESHIFT":
            return Sdk_AssetType.REGISTERED_TIMESHIFT;
        case 5:
        case "URL":
            return Sdk_AssetType.URL;
        case 6:
        case "VOD_TRAILER":
            return Sdk_AssetType.VOD_TRAILER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Sdk_AssetType.UNRECOGNIZED;
    }
}
export function sdk_AssetTypeToJSON(object) {
    switch (object) {
        case Sdk_AssetType.LIVE:
            return "LIVE";
        case Sdk_AssetType.VOD:
            return "VOD";
        case Sdk_AssetType.REPLAY:
            return "REPLAY";
        case Sdk_AssetType.RECORDING:
            return "RECORDING";
        case Sdk_AssetType.REGISTERED_TIMESHIFT:
            return "REGISTERED_TIMESHIFT";
        case Sdk_AssetType.URL:
            return "URL";
        case Sdk_AssetType.VOD_TRAILER:
            return "VOD_TRAILER";
        case Sdk_AssetType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var Sdk_StreamType;
(function (Sdk_StreamType) {
    Sdk_StreamType[Sdk_StreamType["DASH"] = 0] = "DASH";
    Sdk_StreamType[Sdk_StreamType["DASH_WIDEVINE"] = 1] = "DASH_WIDEVINE";
    Sdk_StreamType[Sdk_StreamType["DASH_PLAYREADY"] = 2] = "DASH_PLAYREADY";
    Sdk_StreamType[Sdk_StreamType["HLS7"] = 3] = "HLS7";
    Sdk_StreamType[Sdk_StreamType["HLS7_FAIRPLAY"] = 4] = "HLS7_FAIRPLAY";
    Sdk_StreamType[Sdk_StreamType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Sdk_StreamType || (Sdk_StreamType = {}));
export function sdk_StreamTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "DASH":
            return Sdk_StreamType.DASH;
        case 1:
        case "DASH_WIDEVINE":
            return Sdk_StreamType.DASH_WIDEVINE;
        case 2:
        case "DASH_PLAYREADY":
            return Sdk_StreamType.DASH_PLAYREADY;
        case 3:
        case "HLS7":
            return Sdk_StreamType.HLS7;
        case 4:
        case "HLS7_FAIRPLAY":
            return Sdk_StreamType.HLS7_FAIRPLAY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Sdk_StreamType.UNRECOGNIZED;
    }
}
export function sdk_StreamTypeToJSON(object) {
    switch (object) {
        case Sdk_StreamType.DASH:
            return "DASH";
        case Sdk_StreamType.DASH_WIDEVINE:
            return "DASH_WIDEVINE";
        case Sdk_StreamType.DASH_PLAYREADY:
            return "DASH_PLAYREADY";
        case Sdk_StreamType.HLS7:
            return "HLS7";
        case Sdk_StreamType.HLS7_FAIRPLAY:
            return "HLS7_FAIRPLAY";
        case Sdk_StreamType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var Sdk_MediaTrack_Role;
(function (Sdk_MediaTrack_Role) {
    /** MAIN - DASH: urn:mpeg:dash:role:2011 */
    Sdk_MediaTrack_Role[Sdk_MediaTrack_Role["MAIN"] = 0] = "MAIN";
    Sdk_MediaTrack_Role[Sdk_MediaTrack_Role["ALTERNATE"] = 1] = "ALTERNATE";
    /** CAPTION - HLS: caption */
    Sdk_MediaTrack_Role[Sdk_MediaTrack_Role["CAPTION"] = 2] = "CAPTION";
    /** TRANSCRIBES_SPOKEN_DIALOG - HLS: public.accessibility.transcribes-spoken-dialog */
    Sdk_MediaTrack_Role[Sdk_MediaTrack_Role["TRANSCRIBES_SPOKEN_DIALOG"] = 100] = "TRANSCRIBES_SPOKEN_DIALOG";
    /** DESCRIBES_MUSIC_AND_SOUND - HLS: public.accessibility.describes-music-and-sound */
    Sdk_MediaTrack_Role[Sdk_MediaTrack_Role["DESCRIBES_MUSIC_AND_SOUND"] = 101] = "DESCRIBES_MUSIC_AND_SOUND";
    Sdk_MediaTrack_Role[Sdk_MediaTrack_Role["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Sdk_MediaTrack_Role || (Sdk_MediaTrack_Role = {}));
export function sdk_MediaTrack_RoleFromJSON(object) {
    switch (object) {
        case 0:
        case "MAIN":
            return Sdk_MediaTrack_Role.MAIN;
        case 1:
        case "ALTERNATE":
            return Sdk_MediaTrack_Role.ALTERNATE;
        case 2:
        case "CAPTION":
            return Sdk_MediaTrack_Role.CAPTION;
        case 100:
        case "TRANSCRIBES_SPOKEN_DIALOG":
            return Sdk_MediaTrack_Role.TRANSCRIBES_SPOKEN_DIALOG;
        case 101:
        case "DESCRIBES_MUSIC_AND_SOUND":
            return Sdk_MediaTrack_Role.DESCRIBES_MUSIC_AND_SOUND;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Sdk_MediaTrack_Role.UNRECOGNIZED;
    }
}
export function sdk_MediaTrack_RoleToJSON(object) {
    switch (object) {
        case Sdk_MediaTrack_Role.MAIN:
            return "MAIN";
        case Sdk_MediaTrack_Role.ALTERNATE:
            return "ALTERNATE";
        case Sdk_MediaTrack_Role.CAPTION:
            return "CAPTION";
        case Sdk_MediaTrack_Role.TRANSCRIBES_SPOKEN_DIALOG:
            return "TRANSCRIBES_SPOKEN_DIALOG";
        case Sdk_MediaTrack_Role.DESCRIBES_MUSIC_AND_SOUND:
            return "DESCRIBES_MUSIC_AND_SOUND";
        case Sdk_MediaTrack_Role.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseSdk() {
    return {};
}
export const Sdk = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk();
        return message;
    },
};
function createBaseSdk_PauseAd() {
    return { vastUrl: "", offset: undefined, isChannelAd: undefined };
}
export const Sdk_PauseAd = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.vastUrl !== "") {
            writer.uint32(10).string(message.vastUrl);
        }
        if (message.offset !== undefined) {
            writer.uint32(21).float(message.offset);
        }
        if (message.isChannelAd !== undefined) {
            writer.uint32(24).bool(message.isChannelAd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_PauseAd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.vastUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.offset = reader.float();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vastUrl: isSet(object.vastUrl) ? globalThis.String(object.vastUrl) : "",
            offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vastUrl !== "") {
            obj.vastUrl = message.vastUrl;
        }
        if (message.offset !== undefined) {
            obj.offset = message.offset;
        }
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        return obj;
    },
    create(base) {
        return Sdk_PauseAd.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_PauseAd();
        message.vastUrl = object.vastUrl ?? "";
        message.offset = object.offset ?? undefined;
        message.isChannelAd = object.isChannelAd ?? undefined;
        return message;
    },
};
function createBaseSdk_FastForwardAd() {
    return { vastUrl: "", maxDuration: 0, isChannelAd: undefined };
}
export const Sdk_FastForwardAd = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.vastUrl !== "") {
            writer.uint32(10).string(message.vastUrl);
        }
        if (message.maxDuration !== 0) {
            writer.uint32(21).float(message.maxDuration);
        }
        if (message.isChannelAd !== undefined) {
            writer.uint32(24).bool(message.isChannelAd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_FastForwardAd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.vastUrl = reader.string();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.maxDuration = reader.float();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vastUrl: isSet(object.vastUrl) ? globalThis.String(object.vastUrl) : "",
            maxDuration: isSet(object.maxDuration) ? globalThis.Number(object.maxDuration) : 0,
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vastUrl !== "") {
            obj.vastUrl = message.vastUrl;
        }
        if (message.maxDuration !== 0) {
            obj.maxDuration = message.maxDuration;
        }
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        return obj;
    },
    create(base) {
        return Sdk_FastForwardAd.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_FastForwardAd();
        message.vastUrl = object.vastUrl ?? "";
        message.maxDuration = object.maxDuration ?? 0;
        message.isChannelAd = object.isChannelAd ?? undefined;
        return message;
    },
};
function createBaseSdk_VastAd() {
    return { vastUrl: "", isChannelAd: undefined };
}
export const Sdk_VastAd = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.vastUrl !== "") {
            writer.uint32(10).string(message.vastUrl);
        }
        if (message.isChannelAd !== undefined) {
            writer.uint32(24).bool(message.isChannelAd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_VastAd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.vastUrl = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vastUrl: isSet(object.vastUrl) ? globalThis.String(object.vastUrl) : "",
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vastUrl !== "") {
            obj.vastUrl = message.vastUrl;
        }
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        return obj;
    },
    create(base) {
        return Sdk_VastAd.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_VastAd();
        message.vastUrl = object.vastUrl ?? "";
        message.isChannelAd = object.isChannelAd ?? undefined;
        return message;
    },
};
function createBaseSdk_AdsInfo() {
    return { pause: undefined, fastForward: undefined, preroll: undefined, midroll: undefined };
}
export const Sdk_AdsInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.pause !== undefined) {
            Sdk_PauseAd.encode(message.pause, writer.uint32(10).fork()).ldelim();
        }
        if (message.fastForward !== undefined) {
            Sdk_FastForwardAd.encode(message.fastForward, writer.uint32(18).fork()).ldelim();
        }
        if (message.preroll !== undefined) {
            Sdk_VastAd.encode(message.preroll, writer.uint32(26).fork()).ldelim();
        }
        if (message.midroll !== undefined) {
            Sdk_VastAd.encode(message.midroll, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_AdsInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.pause = Sdk_PauseAd.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.fastForward = Sdk_FastForwardAd.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.preroll = Sdk_VastAd.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.midroll = Sdk_VastAd.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pause: isSet(object.pause) ? Sdk_PauseAd.fromJSON(object.pause) : undefined,
            fastForward: isSet(object.fastForward) ? Sdk_FastForwardAd.fromJSON(object.fastForward) : undefined,
            preroll: isSet(object.preroll) ? Sdk_VastAd.fromJSON(object.preroll) : undefined,
            midroll: isSet(object.midroll) ? Sdk_VastAd.fromJSON(object.midroll) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pause !== undefined) {
            obj.pause = Sdk_PauseAd.toJSON(message.pause);
        }
        if (message.fastForward !== undefined) {
            obj.fastForward = Sdk_FastForwardAd.toJSON(message.fastForward);
        }
        if (message.preroll !== undefined) {
            obj.preroll = Sdk_VastAd.toJSON(message.preroll);
        }
        if (message.midroll !== undefined) {
            obj.midroll = Sdk_VastAd.toJSON(message.midroll);
        }
        return obj;
    },
    create(base) {
        return Sdk_AdsInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_AdsInfo();
        message.pause = (object.pause !== undefined && object.pause !== null)
            ? Sdk_PauseAd.fromPartial(object.pause)
            : undefined;
        message.fastForward = (object.fastForward !== undefined && object.fastForward !== null)
            ? Sdk_FastForwardAd.fromPartial(object.fastForward)
            : undefined;
        message.preroll = (object.preroll !== undefined && object.preroll !== null)
            ? Sdk_VastAd.fromPartial(object.preroll)
            : undefined;
        message.midroll = (object.midroll !== undefined && object.midroll !== null)
            ? Sdk_VastAd.fromPartial(object.midroll)
            : undefined;
        return message;
    },
};
function createBaseSdk_Schedule() {
    return { programStart: 0, markers: [] };
}
export const Sdk_Schedule = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.programStart !== 0) {
            writer.uint32(13).float(message.programStart);
        }
        for (const v of message.markers) {
            Sdk_Schedule_Marker.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Schedule();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.programStart = reader.float();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.markers.push(Sdk_Schedule_Marker.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            programStart: isSet(object.programStart) ? globalThis.Number(object.programStart) : 0,
            markers: globalThis.Array.isArray(object?.markers)
                ? object.markers.map((e) => Sdk_Schedule_Marker.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.programStart !== 0) {
            obj.programStart = message.programStart;
        }
        if (message.markers?.length) {
            obj.markers = message.markers.map((e) => Sdk_Schedule_Marker.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return Sdk_Schedule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Schedule();
        message.programStart = object.programStart ?? 0;
        message.markers = object.markers?.map((e) => Sdk_Schedule_Marker.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSdk_Schedule_Marker() {
    return { start: 0, adsEnd: undefined, promoStart: undefined, end: 0 };
}
export const Sdk_Schedule_Marker = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.start !== 0) {
            writer.uint32(13).float(message.start);
        }
        if (message.adsEnd !== undefined) {
            writer.uint32(21).float(message.adsEnd);
        }
        if (message.promoStart !== undefined) {
            writer.uint32(29).float(message.promoStart);
        }
        if (message.end !== 0) {
            writer.uint32(37).float(message.end);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Schedule_Marker();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.start = reader.float();
                    continue;
                case 2:
                    if (tag !== 21) {
                        break;
                    }
                    message.adsEnd = reader.float();
                    continue;
                case 3:
                    if (tag !== 29) {
                        break;
                    }
                    message.promoStart = reader.float();
                    continue;
                case 4:
                    if (tag !== 37) {
                        break;
                    }
                    message.end = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            start: isSet(object.start) ? globalThis.Number(object.start) : 0,
            adsEnd: isSet(object.adsEnd) ? globalThis.Number(object.adsEnd) : undefined,
            promoStart: isSet(object.promoStart) ? globalThis.Number(object.promoStart) : undefined,
            end: isSet(object.end) ? globalThis.Number(object.end) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.start !== 0) {
            obj.start = message.start;
        }
        if (message.adsEnd !== undefined) {
            obj.adsEnd = message.adsEnd;
        }
        if (message.promoStart !== undefined) {
            obj.promoStart = message.promoStart;
        }
        if (message.end !== 0) {
            obj.end = message.end;
        }
        return obj;
    },
    create(base) {
        return Sdk_Schedule_Marker.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Schedule_Marker();
        message.start = object.start ?? 0;
        message.adsEnd = object.adsEnd ?? undefined;
        message.promoStart = object.promoStart ?? undefined;
        message.end = object.end ?? 0;
        return message;
    },
};
function createBaseSdk_MediaTrack() {
    return { id: "", locale: "", codec: undefined, audioFormat: undefined, rolesWrapper: undefined };
}
export const Sdk_MediaTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.locale !== "") {
            writer.uint32(18).string(message.locale);
        }
        if (message.codec !== undefined) {
            writer.uint32(26).string(message.codec);
        }
        if (message.audioFormat !== undefined) {
            writer.uint32(48).int32(message.audioFormat);
        }
        if (message.rolesWrapper !== undefined) {
            Sdk_MediaTrack_RolesWrapper.encode(message.rolesWrapper, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_MediaTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.locale = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.codec = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.audioFormat = reader.int32();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.rolesWrapper = Sdk_MediaTrack_RolesWrapper.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            locale: isSet(object.locale) ? globalThis.String(object.locale) : "",
            codec: isSet(object.codec) ? globalThis.String(object.codec) : undefined,
            audioFormat: isSet(object.audioFormat) ? sdk_AudioFormatFromJSON(object.audioFormat) : undefined,
            rolesWrapper: isSet(object.rolesWrapper) ? Sdk_MediaTrack_RolesWrapper.fromJSON(object.rolesWrapper) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.locale !== "") {
            obj.locale = message.locale;
        }
        if (message.codec !== undefined) {
            obj.codec = message.codec;
        }
        if (message.audioFormat !== undefined) {
            obj.audioFormat = sdk_AudioFormatToJSON(message.audioFormat);
        }
        if (message.rolesWrapper !== undefined) {
            obj.rolesWrapper = Sdk_MediaTrack_RolesWrapper.toJSON(message.rolesWrapper);
        }
        return obj;
    },
    create(base) {
        return Sdk_MediaTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_MediaTrack();
        message.id = object.id ?? "";
        message.locale = object.locale ?? "";
        message.codec = object.codec ?? undefined;
        message.audioFormat = object.audioFormat ?? undefined;
        message.rolesWrapper = (object.rolesWrapper !== undefined && object.rolesWrapper !== null)
            ? Sdk_MediaTrack_RolesWrapper.fromPartial(object.rolesWrapper)
            : undefined;
        return message;
    },
};
function createBaseSdk_MediaTrack_RolesWrapper() {
    return { roles: [] };
}
export const Sdk_MediaTrack_RolesWrapper = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.roles) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_MediaTrack_RolesWrapper();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag === 8) {
                        message.roles.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.roles.push(reader.int32());
                        }
                        continue;
                    }
                    break;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            roles: globalThis.Array.isArray(object?.roles)
                ? object.roles.map((e) => sdk_MediaTrack_RoleFromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.roles?.length) {
            obj.roles = message.roles.map((e) => sdk_MediaTrack_RoleToJSON(e));
        }
        return obj;
    },
    create(base) {
        return Sdk_MediaTrack_RolesWrapper.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_MediaTrack_RolesWrapper();
        message.roles = object.roles?.map((e) => e) || [];
        return message;
    },
};
function createBaseSdk_CastMediaTrack() {
    return { id: undefined, language: undefined };
}
export const Sdk_CastMediaTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== undefined) {
            writer.uint32(10).string(message.id);
        }
        if (message.language !== undefined) {
            writer.uint32(18).string(message.language);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_CastMediaTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.language = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : undefined,
            language: isSet(object.language) ? globalThis.String(object.language) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.language !== undefined) {
            obj.language = message.language;
        }
        return obj;
    },
    create(base) {
        return Sdk_CastMediaTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_CastMediaTrack();
        message.id = object.id ?? undefined;
        message.language = object.language ?? undefined;
        return message;
    },
};
function createBaseSdk_Media() {
    return { url: "", licenseUrl: undefined, assetType: 0 };
}
export const Sdk_Media = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.licenseUrl !== undefined) {
            writer.uint32(18).string(message.licenseUrl);
        }
        if (message.assetType !== 0) {
            writer.uint32(24).int32(message.assetType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Media();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.licenseUrl = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.assetType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            licenseUrl: isSet(object.licenseUrl) ? globalThis.String(object.licenseUrl) : undefined,
            assetType: isSet(object.assetType) ? sdk_AssetTypeFromJSON(object.assetType) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.licenseUrl !== undefined) {
            obj.licenseUrl = message.licenseUrl;
        }
        if (message.assetType !== 0) {
            obj.assetType = sdk_AssetTypeToJSON(message.assetType);
        }
        return obj;
    },
    create(base) {
        return Sdk_Media.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Media();
        message.url = object.url ?? "";
        message.licenseUrl = object.licenseUrl ?? undefined;
        message.assetType = object.assetType ?? 0;
        return message;
    },
};
function createBaseSdk_Asset() {
    return { streamType: 0, url: "", licenseUrl: undefined, fairPlayCertificateUrl: undefined };
}
export const Sdk_Asset = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.streamType !== 0) {
            writer.uint32(8).int32(message.streamType);
        }
        if (message.url !== "") {
            writer.uint32(18).string(message.url);
        }
        if (message.licenseUrl !== undefined) {
            writer.uint32(26).string(message.licenseUrl);
        }
        if (message.fairPlayCertificateUrl !== undefined) {
            writer.uint32(34).string(message.fairPlayCertificateUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Asset();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.streamType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.licenseUrl = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.fairPlayCertificateUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            streamType: isSet(object.streamType) ? sdk_StreamTypeFromJSON(object.streamType) : 0,
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            licenseUrl: isSet(object.licenseUrl) ? globalThis.String(object.licenseUrl) : undefined,
            fairPlayCertificateUrl: isSet(object.fairPlayCertificateUrl)
                ? globalThis.String(object.fairPlayCertificateUrl)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.streamType !== 0) {
            obj.streamType = sdk_StreamTypeToJSON(message.streamType);
        }
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.licenseUrl !== undefined) {
            obj.licenseUrl = message.licenseUrl;
        }
        if (message.fairPlayCertificateUrl !== undefined) {
            obj.fairPlayCertificateUrl = message.fairPlayCertificateUrl;
        }
        return obj;
    },
    create(base) {
        return Sdk_Asset.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Asset();
        message.streamType = object.streamType ?? 0;
        message.url = object.url ?? "";
        message.licenseUrl = object.licenseUrl ?? undefined;
        message.fairPlayCertificateUrl = object.fairPlayCertificateUrl ?? undefined;
        return message;
    },
};
function createBaseSdk_AssetInfo() {
    return {
        assetType: 0,
        csid: undefined,
        id: undefined,
        streamId: undefined,
        streamProviderId: undefined,
        tcString: undefined,
        telemetryEndpoint: undefined,
        adid: undefined,
    };
}
export const Sdk_AssetInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.assetType !== 0) {
            writer.uint32(8).int32(message.assetType);
        }
        if (message.csid !== undefined) {
            writer.uint32(18).string(message.csid);
        }
        if (message.id !== undefined) {
            writer.uint32(26).string(message.id);
        }
        if (message.streamId !== undefined) {
            writer.uint32(34).string(message.streamId);
        }
        if (message.streamProviderId !== undefined) {
            writer.uint32(42).string(message.streamProviderId);
        }
        if (message.tcString !== undefined) {
            writer.uint32(50).string(message.tcString);
        }
        if (message.telemetryEndpoint !== undefined) {
            writer.uint32(58).string(message.telemetryEndpoint);
        }
        if (message.adid !== undefined) {
            writer.uint32(66).string(message.adid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_AssetInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.assetType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.csid = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.streamId = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.streamProviderId = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.tcString = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.telemetryEndpoint = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.adid = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            assetType: isSet(object.assetType) ? sdk_AssetTypeFromJSON(object.assetType) : 0,
            csid: isSet(object.csid) ? globalThis.String(object.csid) : undefined,
            id: isSet(object.id) ? globalThis.String(object.id) : undefined,
            streamId: isSet(object.streamId) ? globalThis.String(object.streamId) : undefined,
            streamProviderId: isSet(object.streamProviderId) ? globalThis.String(object.streamProviderId) : undefined,
            tcString: isSet(object.tcString) ? globalThis.String(object.tcString) : undefined,
            telemetryEndpoint: isSet(object.telemetryEndpoint) ? globalThis.String(object.telemetryEndpoint) : undefined,
            adid: isSet(object.adid) ? globalThis.String(object.adid) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.assetType !== 0) {
            obj.assetType = sdk_AssetTypeToJSON(message.assetType);
        }
        if (message.csid !== undefined) {
            obj.csid = message.csid;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.streamId !== undefined) {
            obj.streamId = message.streamId;
        }
        if (message.streamProviderId !== undefined) {
            obj.streamProviderId = message.streamProviderId;
        }
        if (message.tcString !== undefined) {
            obj.tcString = message.tcString;
        }
        if (message.telemetryEndpoint !== undefined) {
            obj.telemetryEndpoint = message.telemetryEndpoint;
        }
        if (message.adid !== undefined) {
            obj.adid = message.adid;
        }
        return obj;
    },
    create(base) {
        return Sdk_AssetInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_AssetInfo();
        message.assetType = object.assetType ?? 0;
        message.csid = object.csid ?? undefined;
        message.id = object.id ?? undefined;
        message.streamId = object.streamId ?? undefined;
        message.streamProviderId = object.streamProviderId ?? undefined;
        message.tcString = object.tcString ?? undefined;
        message.telemetryEndpoint = object.telemetryEndpoint ?? undefined;
        message.adid = object.adid ?? undefined;
        return message;
    },
};
function createBaseSdk_PlayOptions() {
    return {
        preferredAudioLanguage: undefined,
        preferredSubtitlesLanguage: undefined,
        startupPosition: undefined,
        preferredAudioFormat: undefined,
        gt12ChannelInfo: undefined,
        adsInfo: undefined,
        assetInfo: undefined,
        autoplay: undefined,
    };
}
export const Sdk_PlayOptions = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.preferredAudioLanguage !== undefined) {
            writer.uint32(18).string(message.preferredAudioLanguage);
        }
        if (message.preferredSubtitlesLanguage !== undefined) {
            writer.uint32(26).string(message.preferredSubtitlesLanguage);
        }
        if (message.startupPosition !== undefined) {
            writer.uint32(33).double(message.startupPosition);
        }
        if (message.preferredAudioFormat !== undefined) {
            writer.uint32(64).int32(message.preferredAudioFormat);
        }
        if (message.gt12ChannelInfo !== undefined) {
            Sdk_PlayOptions_GT12ChannelInfo.encode(message.gt12ChannelInfo, writer.uint32(90).fork()).ldelim();
        }
        if (message.adsInfo !== undefined) {
            Sdk_AdsInfo.encode(message.adsInfo, writer.uint32(74).fork()).ldelim();
        }
        if (message.assetInfo !== undefined) {
            Sdk_AssetInfo.encode(message.assetInfo, writer.uint32(186).fork()).ldelim();
        }
        if (message.autoplay !== undefined) {
            writer.uint32(192).bool(message.autoplay);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_PlayOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.preferredAudioLanguage = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.preferredSubtitlesLanguage = reader.string();
                    continue;
                case 4:
                    if (tag !== 33) {
                        break;
                    }
                    message.startupPosition = reader.double();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.preferredAudioFormat = reader.int32();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.gt12ChannelInfo = Sdk_PlayOptions_GT12ChannelInfo.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.adsInfo = Sdk_AdsInfo.decode(reader, reader.uint32());
                    continue;
                case 23:
                    if (tag !== 186) {
                        break;
                    }
                    message.assetInfo = Sdk_AssetInfo.decode(reader, reader.uint32());
                    continue;
                case 24:
                    if (tag !== 192) {
                        break;
                    }
                    message.autoplay = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            preferredAudioLanguage: isSet(object.preferredAudioLanguage)
                ? globalThis.String(object.preferredAudioLanguage)
                : undefined,
            preferredSubtitlesLanguage: isSet(object.preferredSubtitlesLanguage)
                ? globalThis.String(object.preferredSubtitlesLanguage)
                : undefined,
            startupPosition: isSet(object.startupPosition) ? globalThis.Number(object.startupPosition) : undefined,
            preferredAudioFormat: isSet(object.preferredAudioFormat)
                ? sdk_AudioFormatFromJSON(object.preferredAudioFormat)
                : undefined,
            gt12ChannelInfo: isSet(object.gt12ChannelInfo)
                ? Sdk_PlayOptions_GT12ChannelInfo.fromJSON(object.gt12ChannelInfo)
                : undefined,
            adsInfo: isSet(object.adsInfo) ? Sdk_AdsInfo.fromJSON(object.adsInfo) : undefined,
            assetInfo: isSet(object.assetInfo) ? Sdk_AssetInfo.fromJSON(object.assetInfo) : undefined,
            autoplay: isSet(object.autoplay) ? globalThis.Boolean(object.autoplay) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.preferredAudioLanguage !== undefined) {
            obj.preferredAudioLanguage = message.preferredAudioLanguage;
        }
        if (message.preferredSubtitlesLanguage !== undefined) {
            obj.preferredSubtitlesLanguage = message.preferredSubtitlesLanguage;
        }
        if (message.startupPosition !== undefined) {
            obj.startupPosition = message.startupPosition;
        }
        if (message.preferredAudioFormat !== undefined) {
            obj.preferredAudioFormat = sdk_AudioFormatToJSON(message.preferredAudioFormat);
        }
        if (message.gt12ChannelInfo !== undefined) {
            obj.gt12ChannelInfo = Sdk_PlayOptions_GT12ChannelInfo.toJSON(message.gt12ChannelInfo);
        }
        if (message.adsInfo !== undefined) {
            obj.adsInfo = Sdk_AdsInfo.toJSON(message.adsInfo);
        }
        if (message.assetInfo !== undefined) {
            obj.assetInfo = Sdk_AssetInfo.toJSON(message.assetInfo);
        }
        if (message.autoplay !== undefined) {
            obj.autoplay = message.autoplay;
        }
        return obj;
    },
    create(base) {
        return Sdk_PlayOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_PlayOptions();
        message.preferredAudioLanguage = object.preferredAudioLanguage ?? undefined;
        message.preferredSubtitlesLanguage = object.preferredSubtitlesLanguage ?? undefined;
        message.startupPosition = object.startupPosition ?? undefined;
        message.preferredAudioFormat = object.preferredAudioFormat ?? undefined;
        message.gt12ChannelInfo = (object.gt12ChannelInfo !== undefined && object.gt12ChannelInfo !== null)
            ? Sdk_PlayOptions_GT12ChannelInfo.fromPartial(object.gt12ChannelInfo)
            : undefined;
        message.adsInfo = (object.adsInfo !== undefined && object.adsInfo !== null)
            ? Sdk_AdsInfo.fromPartial(object.adsInfo)
            : undefined;
        message.assetInfo = (object.assetInfo !== undefined && object.assetInfo !== null)
            ? Sdk_AssetInfo.fromPartial(object.assetInfo)
            : undefined;
        message.autoplay = object.autoplay ?? undefined;
        return message;
    },
};
function createBaseSdk_PlayOptions_GT12ChannelInfo() {
    return {
        isGT12BV: false,
        forwardSeekingNeedsMarkers: false,
        adBreakSkipAllowed: false,
        forwardSeekingAllowed: false,
        schedule: [],
    };
}
export const Sdk_PlayOptions_GT12ChannelInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.isGT12BV !== false) {
            writer.uint32(8).bool(message.isGT12BV);
        }
        if (message.forwardSeekingNeedsMarkers !== false) {
            writer.uint32(16).bool(message.forwardSeekingNeedsMarkers);
        }
        if (message.adBreakSkipAllowed !== false) {
            writer.uint32(24).bool(message.adBreakSkipAllowed);
        }
        if (message.forwardSeekingAllowed !== false) {
            writer.uint32(32).bool(message.forwardSeekingAllowed);
        }
        for (const v of message.schedule) {
            Sdk_Schedule.encode(v, writer.uint32(194).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_PlayOptions_GT12ChannelInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.isGT12BV = reader.bool();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.forwardSeekingNeedsMarkers = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.adBreakSkipAllowed = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.forwardSeekingAllowed = reader.bool();
                    continue;
                case 24:
                    if (tag !== 194) {
                        break;
                    }
                    message.schedule.push(Sdk_Schedule.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isGT12BV: isSet(object.isGT12BV) ? globalThis.Boolean(object.isGT12BV) : false,
            forwardSeekingNeedsMarkers: isSet(object.forwardSeekingNeedsMarkers)
                ? globalThis.Boolean(object.forwardSeekingNeedsMarkers)
                : false,
            adBreakSkipAllowed: isSet(object.adBreakSkipAllowed) ? globalThis.Boolean(object.adBreakSkipAllowed) : false,
            forwardSeekingAllowed: isSet(object.forwardSeekingAllowed)
                ? globalThis.Boolean(object.forwardSeekingAllowed)
                : false,
            schedule: globalThis.Array.isArray(object?.schedule)
                ? object.schedule.map((e) => Sdk_Schedule.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isGT12BV !== false) {
            obj.isGT12BV = message.isGT12BV;
        }
        if (message.forwardSeekingNeedsMarkers !== false) {
            obj.forwardSeekingNeedsMarkers = message.forwardSeekingNeedsMarkers;
        }
        if (message.adBreakSkipAllowed !== false) {
            obj.adBreakSkipAllowed = message.adBreakSkipAllowed;
        }
        if (message.forwardSeekingAllowed !== false) {
            obj.forwardSeekingAllowed = message.forwardSeekingAllowed;
        }
        if (message.schedule?.length) {
            obj.schedule = message.schedule.map((e) => Sdk_Schedule.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return Sdk_PlayOptions_GT12ChannelInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_PlayOptions_GT12ChannelInfo();
        message.isGT12BV = object.isGT12BV ?? false;
        message.forwardSeekingNeedsMarkers = object.forwardSeekingNeedsMarkers ?? false;
        message.adBreakSkipAllowed = object.adBreakSkipAllowed ?? false;
        message.forwardSeekingAllowed = object.forwardSeekingAllowed ?? false;
        message.schedule = object.schedule?.map((e) => Sdk_Schedule.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSdk_DeviceCapabilities() {
    return { streamTypeInformation: [], hdcpLevel: undefined, audioCodecs: [], videoCodecs: [], subtitlesCodecs: [] };
}
export const Sdk_DeviceCapabilities = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.streamTypeInformation) {
            Sdk_DeviceCapabilities_StreamTypeInformation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.hdcpLevel !== undefined) {
            Sdk_DeviceCapabilities_HdcpInformation.encode(message.hdcpLevel, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.audioCodecs) {
            writer.uint32(26).string(v);
        }
        for (const v of message.videoCodecs) {
            writer.uint32(34).string(v);
        }
        for (const v of message.subtitlesCodecs) {
            writer.uint32(42).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_DeviceCapabilities();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.streamTypeInformation.push(Sdk_DeviceCapabilities_StreamTypeInformation.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.hdcpLevel = Sdk_DeviceCapabilities_HdcpInformation.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.audioCodecs.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.videoCodecs.push(reader.string());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.subtitlesCodecs.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            streamTypeInformation: globalThis.Array.isArray(object?.streamTypeInformation)
                ? object.streamTypeInformation.map((e) => Sdk_DeviceCapabilities_StreamTypeInformation.fromJSON(e))
                : [],
            hdcpLevel: isSet(object.hdcpLevel)
                ? Sdk_DeviceCapabilities_HdcpInformation.fromJSON(object.hdcpLevel)
                : undefined,
            audioCodecs: globalThis.Array.isArray(object?.audioCodecs)
                ? object.audioCodecs.map((e) => globalThis.String(e))
                : [],
            videoCodecs: globalThis.Array.isArray(object?.videoCodecs)
                ? object.videoCodecs.map((e) => globalThis.String(e))
                : [],
            subtitlesCodecs: globalThis.Array.isArray(object?.subtitlesCodecs)
                ? object.subtitlesCodecs.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.streamTypeInformation?.length) {
            obj.streamTypeInformation = message.streamTypeInformation.map((e) => Sdk_DeviceCapabilities_StreamTypeInformation.toJSON(e));
        }
        if (message.hdcpLevel !== undefined) {
            obj.hdcpLevel = Sdk_DeviceCapabilities_HdcpInformation.toJSON(message.hdcpLevel);
        }
        if (message.audioCodecs?.length) {
            obj.audioCodecs = message.audioCodecs;
        }
        if (message.videoCodecs?.length) {
            obj.videoCodecs = message.videoCodecs;
        }
        if (message.subtitlesCodecs?.length) {
            obj.subtitlesCodecs = message.subtitlesCodecs;
        }
        return obj;
    },
    create(base) {
        return Sdk_DeviceCapabilities.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_DeviceCapabilities();
        message.streamTypeInformation =
            object.streamTypeInformation?.map((e) => Sdk_DeviceCapabilities_StreamTypeInformation.fromPartial(e)) || [];
        message.hdcpLevel = (object.hdcpLevel !== undefined && object.hdcpLevel !== null)
            ? Sdk_DeviceCapabilities_HdcpInformation.fromPartial(object.hdcpLevel)
            : undefined;
        message.audioCodecs = object.audioCodecs?.map((e) => e) || [];
        message.videoCodecs = object.videoCodecs?.map((e) => e) || [];
        message.subtitlesCodecs = object.subtitlesCodecs?.map((e) => e) || [];
        return message;
    },
};
function createBaseSdk_DeviceCapabilities_StreamTypeInformation() {
    return { type: 0, maxSecurityLevel: undefined, version: undefined };
}
export const Sdk_DeviceCapabilities_StreamTypeInformation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (message.maxSecurityLevel !== undefined) {
            writer.uint32(18).string(message.maxSecurityLevel);
        }
        if (message.version !== undefined) {
            writer.uint32(26).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_DeviceCapabilities_StreamTypeInformation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.maxSecurityLevel = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.version = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? sdk_StreamTypeFromJSON(object.type) : 0,
            maxSecurityLevel: isSet(object.maxSecurityLevel) ? globalThis.String(object.maxSecurityLevel) : undefined,
            version: isSet(object.version) ? globalThis.String(object.version) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== 0) {
            obj.type = sdk_StreamTypeToJSON(message.type);
        }
        if (message.maxSecurityLevel !== undefined) {
            obj.maxSecurityLevel = message.maxSecurityLevel;
        }
        if (message.version !== undefined) {
            obj.version = message.version;
        }
        return obj;
    },
    create(base) {
        return Sdk_DeviceCapabilities_StreamTypeInformation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_DeviceCapabilities_StreamTypeInformation();
        message.type = object.type ?? 0;
        message.maxSecurityLevel = object.maxSecurityLevel ?? undefined;
        message.version = object.version ?? undefined;
        return message;
    },
};
function createBaseSdk_DeviceCapabilities_HdcpInformation() {
    return { connectedVersion: undefined, maxSupportedVersion: undefined };
}
export const Sdk_DeviceCapabilities_HdcpInformation = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.connectedVersion !== undefined) {
            writer.uint32(10).string(message.connectedVersion);
        }
        if (message.maxSupportedVersion !== undefined) {
            writer.uint32(18).string(message.maxSupportedVersion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_DeviceCapabilities_HdcpInformation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.connectedVersion = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.maxSupportedVersion = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectedVersion: isSet(object.connectedVersion) ? globalThis.String(object.connectedVersion) : undefined,
            maxSupportedVersion: isSet(object.maxSupportedVersion)
                ? globalThis.String(object.maxSupportedVersion)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectedVersion !== undefined) {
            obj.connectedVersion = message.connectedVersion;
        }
        if (message.maxSupportedVersion !== undefined) {
            obj.maxSupportedVersion = message.maxSupportedVersion;
        }
        return obj;
    },
    create(base) {
        return Sdk_DeviceCapabilities_HdcpInformation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_DeviceCapabilities_HdcpInformation();
        message.connectedVersion = object.connectedVersion ?? undefined;
        message.maxSupportedVersion = object.maxSupportedVersion ?? undefined;
        return message;
    },
};
function createBaseSdk_ThumbnailData() {
    return { url: "", location: undefined, layout: undefined };
}
export const Sdk_ThumbnailData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.location !== undefined) {
            Sdk_ThumbnailData_ThumbnailLayout.encode(message.location, writer.uint32(18).fork()).ldelim();
        }
        if (message.layout !== undefined) {
            Sdk_ThumbnailData_ThumbnailLayout.encode(message.layout, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_ThumbnailData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.location = Sdk_ThumbnailData_ThumbnailLayout.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.layout = Sdk_ThumbnailData_ThumbnailLayout.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            location: isSet(object.location) ? Sdk_ThumbnailData_ThumbnailLayout.fromJSON(object.location) : undefined,
            layout: isSet(object.layout) ? Sdk_ThumbnailData_ThumbnailLayout.fromJSON(object.layout) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.location !== undefined) {
            obj.location = Sdk_ThumbnailData_ThumbnailLayout.toJSON(message.location);
        }
        if (message.layout !== undefined) {
            obj.layout = Sdk_ThumbnailData_ThumbnailLayout.toJSON(message.layout);
        }
        return obj;
    },
    create(base) {
        return Sdk_ThumbnailData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_ThumbnailData();
        message.url = object.url ?? "";
        message.location = (object.location !== undefined && object.location !== null)
            ? Sdk_ThumbnailData_ThumbnailLayout.fromPartial(object.location)
            : undefined;
        message.layout = (object.layout !== undefined && object.layout !== null)
            ? Sdk_ThumbnailData_ThumbnailLayout.fromPartial(object.layout)
            : undefined;
        return message;
    },
};
function createBaseSdk_ThumbnailData_ThumbnailLayout() {
    return { col: 0, row: 0 };
}
export const Sdk_ThumbnailData_ThumbnailLayout = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.col !== 0) {
            writer.uint32(8).uint32(message.col);
        }
        if (message.row !== 0) {
            writer.uint32(16).uint32(message.row);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_ThumbnailData_ThumbnailLayout();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.col = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.row = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            col: isSet(object.col) ? globalThis.Number(object.col) : 0,
            row: isSet(object.row) ? globalThis.Number(object.row) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.col !== 0) {
            obj.col = Math.round(message.col);
        }
        if (message.row !== 0) {
            obj.row = Math.round(message.row);
        }
        return obj;
    },
    create(base) {
        return Sdk_ThumbnailData_ThumbnailLayout.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_ThumbnailData_ThumbnailLayout();
        message.col = object.col ?? 0;
        message.row = object.row ?? 0;
        return message;
    },
};
function createBaseSdk_Player() {
    return {};
}
export const Sdk_Player = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player();
        return message;
    },
};
function createBaseSdk_Player_Create() {
    return { options: undefined };
}
export const Sdk_Player_Create = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.options !== undefined) {
            Sdk_Player_Create_PlayerOptions.encode(message.options, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Create();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.options = Sdk_Player_Create_PlayerOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { options: isSet(object.options) ? Sdk_Player_Create_PlayerOptions.fromJSON(object.options) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.options !== undefined) {
            obj.options = Sdk_Player_Create_PlayerOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_Create.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_Create();
        message.options = (object.options !== undefined && object.options !== null)
            ? Sdk_Player_Create_PlayerOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseSdk_Player_Create_PlayerOptions() {
    return {
        publicId: undefined,
        appVersion: undefined,
        appName: undefined,
        license: undefined,
        licenseValidationUrl: undefined,
        stepBackwardDuration: undefined,
        stepForwardDuration: undefined,
        muted: undefined,
        latencyMeasurementInterval: undefined,
        enableOpenMeasurement: undefined,
        enableMediaSession: undefined,
    };
}
export const Sdk_Player_Create_PlayerOptions = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.publicId !== undefined) {
            writer.uint32(10).string(message.publicId);
        }
        if (message.appVersion !== undefined) {
            writer.uint32(18).string(message.appVersion);
        }
        if (message.appName !== undefined) {
            writer.uint32(26).string(message.appName);
        }
        if (message.license !== undefined) {
            writer.uint32(34).string(message.license);
        }
        if (message.licenseValidationUrl !== undefined) {
            writer.uint32(42).string(message.licenseValidationUrl);
        }
        if (message.stepBackwardDuration !== undefined) {
            writer.uint32(53).float(message.stepBackwardDuration);
        }
        if (message.stepForwardDuration !== undefined) {
            writer.uint32(61).float(message.stepForwardDuration);
        }
        if (message.muted !== undefined) {
            writer.uint32(64).bool(message.muted);
        }
        if (message.latencyMeasurementInterval !== undefined) {
            writer.uint32(72).int32(message.latencyMeasurementInterval);
        }
        if (message.enableOpenMeasurement !== undefined) {
            writer.uint32(80).bool(message.enableOpenMeasurement);
        }
        if (message.enableMediaSession !== undefined) {
            writer.uint32(88).bool(message.enableMediaSession);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Create_PlayerOptions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.publicId = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.appVersion = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.appName = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.license = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.licenseValidationUrl = reader.string();
                    continue;
                case 6:
                    if (tag !== 53) {
                        break;
                    }
                    message.stepBackwardDuration = reader.float();
                    continue;
                case 7:
                    if (tag !== 61) {
                        break;
                    }
                    message.stepForwardDuration = reader.float();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.muted = reader.bool();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.latencyMeasurementInterval = reader.int32();
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.enableOpenMeasurement = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.enableMediaSession = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            publicId: isSet(object.publicId) ? globalThis.String(object.publicId) : undefined,
            appVersion: isSet(object.appVersion) ? globalThis.String(object.appVersion) : undefined,
            appName: isSet(object.appName) ? globalThis.String(object.appName) : undefined,
            license: isSet(object.license) ? globalThis.String(object.license) : undefined,
            licenseValidationUrl: isSet(object.licenseValidationUrl)
                ? globalThis.String(object.licenseValidationUrl)
                : undefined,
            stepBackwardDuration: isSet(object.stepBackwardDuration)
                ? globalThis.Number(object.stepBackwardDuration)
                : undefined,
            stepForwardDuration: isSet(object.stepForwardDuration)
                ? globalThis.Number(object.stepForwardDuration)
                : undefined,
            muted: isSet(object.muted) ? globalThis.Boolean(object.muted) : undefined,
            latencyMeasurementInterval: isSet(object.latencyMeasurementInterval)
                ? globalThis.Number(object.latencyMeasurementInterval)
                : undefined,
            enableOpenMeasurement: isSet(object.enableOpenMeasurement)
                ? globalThis.Boolean(object.enableOpenMeasurement)
                : undefined,
            enableMediaSession: isSet(object.enableMediaSession) ? globalThis.Boolean(object.enableMediaSession) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.publicId !== undefined) {
            obj.publicId = message.publicId;
        }
        if (message.appVersion !== undefined) {
            obj.appVersion = message.appVersion;
        }
        if (message.appName !== undefined) {
            obj.appName = message.appName;
        }
        if (message.license !== undefined) {
            obj.license = message.license;
        }
        if (message.licenseValidationUrl !== undefined) {
            obj.licenseValidationUrl = message.licenseValidationUrl;
        }
        if (message.stepBackwardDuration !== undefined) {
            obj.stepBackwardDuration = message.stepBackwardDuration;
        }
        if (message.stepForwardDuration !== undefined) {
            obj.stepForwardDuration = message.stepForwardDuration;
        }
        if (message.muted !== undefined) {
            obj.muted = message.muted;
        }
        if (message.latencyMeasurementInterval !== undefined) {
            obj.latencyMeasurementInterval = Math.round(message.latencyMeasurementInterval);
        }
        if (message.enableOpenMeasurement !== undefined) {
            obj.enableOpenMeasurement = message.enableOpenMeasurement;
        }
        if (message.enableMediaSession !== undefined) {
            obj.enableMediaSession = message.enableMediaSession;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_Create_PlayerOptions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_Create_PlayerOptions();
        message.publicId = object.publicId ?? undefined;
        message.appVersion = object.appVersion ?? undefined;
        message.appName = object.appName ?? undefined;
        message.license = object.license ?? undefined;
        message.licenseValidationUrl = object.licenseValidationUrl ?? undefined;
        message.stepBackwardDuration = object.stepBackwardDuration ?? undefined;
        message.stepForwardDuration = object.stepForwardDuration ?? undefined;
        message.muted = object.muted ?? undefined;
        message.latencyMeasurementInterval = object.latencyMeasurementInterval ?? undefined;
        message.enableOpenMeasurement = object.enableOpenMeasurement ?? undefined;
        message.enableMediaSession = object.enableMediaSession ?? undefined;
        return message;
    },
};
function createBaseSdk_Player_PlayUrl() {
    return { asset: undefined, options: undefined };
}
export const Sdk_Player_PlayUrl = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.asset !== undefined) {
            Sdk_Asset.encode(message.asset, writer.uint32(10).fork()).ldelim();
        }
        if (message.options !== undefined) {
            Sdk_PlayOptions.encode(message.options, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_PlayUrl();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.asset = Sdk_Asset.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.options = Sdk_PlayOptions.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            asset: isSet(object.asset) ? Sdk_Asset.fromJSON(object.asset) : undefined,
            options: isSet(object.options) ? Sdk_PlayOptions.fromJSON(object.options) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.asset !== undefined) {
            obj.asset = Sdk_Asset.toJSON(message.asset);
        }
        if (message.options !== undefined) {
            obj.options = Sdk_PlayOptions.toJSON(message.options);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_PlayUrl.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_PlayUrl();
        message.asset = (object.asset !== undefined && object.asset !== null)
            ? Sdk_Asset.fromPartial(object.asset)
            : undefined;
        message.options = (object.options !== undefined && object.options !== null)
            ? Sdk_PlayOptions.fromPartial(object.options)
            : undefined;
        return message;
    },
};
function createBaseSdk_Player_Play() {
    return {};
}
export const Sdk_Player_Play = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Play();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_Play.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_Play();
        return message;
    },
};
function createBaseSdk_Player_GetAvailableAudioTracks() {
    return {};
}
export const Sdk_Player_GetAvailableAudioTracks = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_GetAvailableAudioTracks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_GetAvailableAudioTracks.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_GetAvailableAudioTracks();
        return message;
    },
};
function createBaseSdk_Player_SetAudioTrack() {
    return { track: undefined };
}
export const Sdk_Player_SetAudioTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.track !== undefined) {
            Sdk_MediaTrack.encode(message.track, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SetAudioTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.track = Sdk_MediaTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { track: isSet(object.track) ? Sdk_MediaTrack.fromJSON(object.track) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.track !== undefined) {
            obj.track = Sdk_MediaTrack.toJSON(message.track);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SetAudioTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SetAudioTrack();
        message.track = (object.track !== undefined && object.track !== null)
            ? Sdk_MediaTrack.fromPartial(object.track)
            : undefined;
        return message;
    },
};
function createBaseSdk_Player_GetSelectedAudioTrack() {
    return {};
}
export const Sdk_Player_GetSelectedAudioTrack = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_GetSelectedAudioTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_GetSelectedAudioTrack.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_GetSelectedAudioTrack();
        return message;
    },
};
function createBaseSdk_Player_GetProperties() {
    return {};
}
export const Sdk_Player_GetProperties = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_GetProperties();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_GetProperties.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_GetProperties();
        return message;
    },
};
function createBaseSdk_Player_GetAvailableSubtitlesTracks() {
    return {};
}
export const Sdk_Player_GetAvailableSubtitlesTracks = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_GetAvailableSubtitlesTracks();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_GetAvailableSubtitlesTracks.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_GetAvailableSubtitlesTracks();
        return message;
    },
};
function createBaseSdk_Player_SetSubtitlesTrack() {
    return { track: undefined };
}
export const Sdk_Player_SetSubtitlesTrack = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.track !== undefined) {
            Sdk_MediaTrack.encode(message.track, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SetSubtitlesTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.track = Sdk_MediaTrack.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { track: isSet(object.track) ? Sdk_MediaTrack.fromJSON(object.track) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.track !== undefined) {
            obj.track = Sdk_MediaTrack.toJSON(message.track);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SetSubtitlesTrack.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SetSubtitlesTrack();
        message.track = (object.track !== undefined && object.track !== null)
            ? Sdk_MediaTrack.fromPartial(object.track)
            : undefined;
        return message;
    },
};
function createBaseSdk_Player_GetSelectedSubtitlesTrack() {
    return {};
}
export const Sdk_Player_GetSelectedSubtitlesTrack = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_GetSelectedSubtitlesTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_GetSelectedSubtitlesTrack.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_GetSelectedSubtitlesTrack();
        return message;
    },
};
function createBaseSdk_Player_Pause() {
    return {};
}
export const Sdk_Player_Pause = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Pause();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_Pause.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_Pause();
        return message;
    },
};
function createBaseSdk_Player_Seek() {
    return { time: 0 };
}
export const Sdk_Player_Seek = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.time !== 0) {
            writer.uint32(13).float(message.time);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Seek();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.time = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { time: isSet(object.time) ? globalThis.Number(object.time) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.time !== 0) {
            obj.time = message.time;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_Seek.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_Seek();
        message.time = object.time ?? 0;
        return message;
    },
};
function createBaseSdk_Player_SeekForward() {
    return { steps: 0 };
}
export const Sdk_Player_SeekForward = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.steps !== 0) {
            writer.uint32(8).uint32(message.steps);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SeekForward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.steps = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { steps: isSet(object.steps) ? globalThis.Number(object.steps) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.steps !== 0) {
            obj.steps = Math.round(message.steps);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SeekForward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SeekForward();
        message.steps = object.steps ?? 0;
        return message;
    },
};
function createBaseSdk_Player_SeekBackward() {
    return { steps: 0 };
}
export const Sdk_Player_SeekBackward = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.steps !== 0) {
            writer.uint32(8).uint32(message.steps);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SeekBackward();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.steps = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { steps: isSet(object.steps) ? globalThis.Number(object.steps) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.steps !== 0) {
            obj.steps = Math.round(message.steps);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SeekBackward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SeekBackward();
        message.steps = object.steps ?? 0;
        return message;
    },
};
function createBaseSdk_Player_SeekToAdBreakEnd() {
    return {};
}
export const Sdk_Player_SeekToAdBreakEnd = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SeekToAdBreakEnd();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_SeekToAdBreakEnd.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_SeekToAdBreakEnd();
        return message;
    },
};
function createBaseSdk_Player_SetVolume() {
    return { volume: 0 };
}
export const Sdk_Player_SetVolume = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.volume !== 0) {
            writer.uint32(13).float(message.volume);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SetVolume();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.volume = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.volume !== 0) {
            obj.volume = message.volume;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SetVolume.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SetVolume();
        message.volume = object.volume ?? 0;
        return message;
    },
};
function createBaseSdk_Player_SetRate() {
    return { rate: 0 };
}
export const Sdk_Player_SetRate = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.rate !== 0) {
            writer.uint32(13).float(message.rate);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SetRate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 13) {
                        break;
                    }
                    message.rate = reader.float();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { rate: isSet(object.rate) ? globalThis.Number(object.rate) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.rate !== 0) {
            obj.rate = message.rate;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SetRate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SetRate();
        message.rate = object.rate ?? 0;
        return message;
    },
};
function createBaseSdk_Player_LoadVast() {
    return { ad: undefined };
}
export const Sdk_Player_LoadVast = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.ad !== undefined) {
            Sdk_VastAd.encode(message.ad, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_LoadVast();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.ad = Sdk_VastAd.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { ad: isSet(object.ad) ? Sdk_VastAd.fromJSON(object.ad) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.ad !== undefined) {
            obj.ad = Sdk_VastAd.toJSON(message.ad);
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_LoadVast.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_LoadVast();
        message.ad = (object.ad !== undefined && object.ad !== null) ? Sdk_VastAd.fromPartial(object.ad) : undefined;
        return message;
    },
};
function createBaseSdk_Player_SetStaticProgramInfoCallback() {
    return { programId: 0, startTime: 0, duration: 0 };
}
export const Sdk_Player_SetStaticProgramInfoCallback = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.programId !== 0) {
            writer.uint32(8).uint32(message.programId);
        }
        if (message.startTime !== 0) {
            writer.uint32(17).double(message.startTime);
        }
        if (message.duration !== 0) {
            writer.uint32(25).double(message.duration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_SetStaticProgramInfoCallback();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.programId = reader.uint32();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.startTime = reader.double();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.duration = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            programId: isSet(object.programId) ? globalThis.Number(object.programId) : 0,
            startTime: isSet(object.startTime) ? globalThis.Number(object.startTime) : 0,
            duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.programId !== 0) {
            obj.programId = Math.round(message.programId);
        }
        if (message.startTime !== 0) {
            obj.startTime = message.startTime;
        }
        if (message.duration !== 0) {
            obj.duration = message.duration;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_SetStaticProgramInfoCallback.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_SetStaticProgramInfoCallback();
        message.programId = object.programId ?? 0;
        message.startTime = object.startTime ?? 0;
        message.duration = object.duration ?? 0;
        return message;
    },
};
function createBaseSdk_Player_Stop() {
    return {};
}
export const Sdk_Player_Stop = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Stop();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_Stop.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_Stop();
        return message;
    },
};
function createBaseSdk_Player_Destroy() {
    return {};
}
export const Sdk_Player_Destroy = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_Destroy();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return Sdk_Player_Destroy.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSdk_Player_Destroy();
        return message;
    },
};
function createBaseSdk_Player_PauseAdParsed() {
    return { offset: 0, adUrl: undefined, adWidth: undefined, adHeight: undefined, isChannelAd: undefined };
}
export const Sdk_Player_PauseAdParsed = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.offset !== 0) {
            writer.uint32(8).int32(message.offset);
        }
        if (message.adUrl !== undefined) {
            writer.uint32(18).string(message.adUrl);
        }
        if (message.adWidth !== undefined) {
            writer.uint32(24).int32(message.adWidth);
        }
        if (message.adHeight !== undefined) {
            writer.uint32(32).int32(message.adHeight);
        }
        if (message.isChannelAd !== undefined) {
            writer.uint32(40).bool(message.isChannelAd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_PauseAdParsed();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.offset = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.adUrl = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.adWidth = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.adHeight = reader.int32();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.isChannelAd = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
            adUrl: isSet(object.adUrl) ? globalThis.String(object.adUrl) : undefined,
            adWidth: isSet(object.adWidth) ? globalThis.Number(object.adWidth) : undefined,
            adHeight: isSet(object.adHeight) ? globalThis.Number(object.adHeight) : undefined,
            isChannelAd: isSet(object.isChannelAd) ? globalThis.Boolean(object.isChannelAd) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.offset !== 0) {
            obj.offset = Math.round(message.offset);
        }
        if (message.adUrl !== undefined) {
            obj.adUrl = message.adUrl;
        }
        if (message.adWidth !== undefined) {
            obj.adWidth = Math.round(message.adWidth);
        }
        if (message.adHeight !== undefined) {
            obj.adHeight = Math.round(message.adHeight);
        }
        if (message.isChannelAd !== undefined) {
            obj.isChannelAd = message.isChannelAd;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_PauseAdParsed.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_PauseAdParsed();
        message.offset = object.offset ?? 0;
        message.adUrl = object.adUrl ?? undefined;
        message.adWidth = object.adWidth ?? undefined;
        message.adHeight = object.adHeight ?? undefined;
        message.isChannelAd = object.isChannelAd ?? undefined;
        return message;
    },
};
function createBaseSdk_Player_ThumbnailData() {
    return { time: 0 };
}
export const Sdk_Player_ThumbnailData = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.time !== 0) {
            writer.uint32(9).double(message.time);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Player_ThumbnailData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.time = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { time: isSet(object.time) ? globalThis.Number(object.time) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.time !== 0) {
            obj.time = message.time;
        }
        return obj;
    },
    create(base) {
        return Sdk_Player_ThumbnailData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Player_ThumbnailData();
        message.time = object.time ?? 0;
        return message;
    },
};
function createBaseSdk_Action() {
    return {
        playerCreate: undefined,
        playerPlayUrl: undefined,
        playerPlay: undefined,
        playerPause: undefined,
        playerSeek: undefined,
        playerSeekForward: undefined,
        playerSeekBackward: undefined,
        playerSetVolume: undefined,
        playerSetRate: undefined,
        playerGetAvailableAudioTracks: undefined,
        playerSetAudioTrack: undefined,
        playerSetSubtitlesTrack: undefined,
        playerGetSelectedAudioTrack: undefined,
        playerGetAvailableSubtitlesTracks: undefined,
        playerGetSelectedSubtitlesTrack: undefined,
        playerGetProperties: undefined,
        playerLoadVast: undefined,
        playerSetStaticProgramInfoCallback: undefined,
        playerStop: undefined,
        playerDestroy: undefined,
        playerSeekToAdBreakEnd: undefined,
        playerThumbnailData: undefined,
    };
}
export const Sdk_Action = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.playerCreate !== undefined) {
            Sdk_Player_Create.encode(message.playerCreate, writer.uint32(10).fork()).ldelim();
        }
        if (message.playerPlayUrl !== undefined) {
            Sdk_Player_PlayUrl.encode(message.playerPlayUrl, writer.uint32(18).fork()).ldelim();
        }
        if (message.playerPlay !== undefined) {
            Sdk_Player_Play.encode(message.playerPlay, writer.uint32(26).fork()).ldelim();
        }
        if (message.playerPause !== undefined) {
            Sdk_Player_Pause.encode(message.playerPause, writer.uint32(34).fork()).ldelim();
        }
        if (message.playerSeek !== undefined) {
            Sdk_Player_Seek.encode(message.playerSeek, writer.uint32(42).fork()).ldelim();
        }
        if (message.playerSeekForward !== undefined) {
            Sdk_Player_SeekForward.encode(message.playerSeekForward, writer.uint32(50).fork()).ldelim();
        }
        if (message.playerSeekBackward !== undefined) {
            Sdk_Player_SeekBackward.encode(message.playerSeekBackward, writer.uint32(58).fork()).ldelim();
        }
        if (message.playerSetVolume !== undefined) {
            Sdk_Player_SetVolume.encode(message.playerSetVolume, writer.uint32(66).fork()).ldelim();
        }
        if (message.playerSetRate !== undefined) {
            Sdk_Player_SetRate.encode(message.playerSetRate, writer.uint32(74).fork()).ldelim();
        }
        if (message.playerGetAvailableAudioTracks !== undefined) {
            Sdk_Player_GetAvailableAudioTracks.encode(message.playerGetAvailableAudioTracks, writer.uint32(82).fork())
                .ldelim();
        }
        if (message.playerSetAudioTrack !== undefined) {
            Sdk_Player_SetAudioTrack.encode(message.playerSetAudioTrack, writer.uint32(90).fork()).ldelim();
        }
        if (message.playerSetSubtitlesTrack !== undefined) {
            Sdk_Player_SetSubtitlesTrack.encode(message.playerSetSubtitlesTrack, writer.uint32(98).fork()).ldelim();
        }
        if (message.playerGetSelectedAudioTrack !== undefined) {
            Sdk_Player_GetSelectedAudioTrack.encode(message.playerGetSelectedAudioTrack, writer.uint32(106).fork()).ldelim();
        }
        if (message.playerGetAvailableSubtitlesTracks !== undefined) {
            Sdk_Player_GetAvailableSubtitlesTracks.encode(message.playerGetAvailableSubtitlesTracks, writer.uint32(114).fork()).ldelim();
        }
        if (message.playerGetSelectedSubtitlesTrack !== undefined) {
            Sdk_Player_GetSelectedSubtitlesTrack.encode(message.playerGetSelectedSubtitlesTrack, writer.uint32(122).fork())
                .ldelim();
        }
        if (message.playerGetProperties !== undefined) {
            Sdk_Player_GetProperties.encode(message.playerGetProperties, writer.uint32(130).fork()).ldelim();
        }
        if (message.playerLoadVast !== undefined) {
            Sdk_Player_LoadVast.encode(message.playerLoadVast, writer.uint32(170).fork()).ldelim();
        }
        if (message.playerSetStaticProgramInfoCallback !== undefined) {
            Sdk_Player_SetStaticProgramInfoCallback.encode(message.playerSetStaticProgramInfoCallback, writer.uint32(178).fork()).ldelim();
        }
        if (message.playerStop !== undefined) {
            Sdk_Player_Stop.encode(message.playerStop, writer.uint32(138).fork()).ldelim();
        }
        if (message.playerDestroy !== undefined) {
            Sdk_Player_Destroy.encode(message.playerDestroy, writer.uint32(146).fork()).ldelim();
        }
        if (message.playerSeekToAdBreakEnd !== undefined) {
            Sdk_Player_SeekToAdBreakEnd.encode(message.playerSeekToAdBreakEnd, writer.uint32(154).fork()).ldelim();
        }
        if (message.playerThumbnailData !== undefined) {
            Sdk_Player_ThumbnailData.encode(message.playerThumbnailData, writer.uint32(162).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSdk_Action();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playerCreate = Sdk_Player_Create.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.playerPlayUrl = Sdk_Player_PlayUrl.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.playerPlay = Sdk_Player_Play.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.playerPause = Sdk_Player_Pause.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.playerSeek = Sdk_Player_Seek.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.playerSeekForward = Sdk_Player_SeekForward.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.playerSeekBackward = Sdk_Player_SeekBackward.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.playerSetVolume = Sdk_Player_SetVolume.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.playerSetRate = Sdk_Player_SetRate.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.playerGetAvailableAudioTracks = Sdk_Player_GetAvailableAudioTracks.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.playerSetAudioTrack = Sdk_Player_SetAudioTrack.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.playerSetSubtitlesTrack = Sdk_Player_SetSubtitlesTrack.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.playerGetSelectedAudioTrack = Sdk_Player_GetSelectedAudioTrack.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.playerGetAvailableSubtitlesTracks = Sdk_Player_GetAvailableSubtitlesTracks.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.playerGetSelectedSubtitlesTrack = Sdk_Player_GetSelectedSubtitlesTrack.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.playerGetProperties = Sdk_Player_GetProperties.decode(reader, reader.uint32());
                    continue;
                case 21:
                    if (tag !== 170) {
                        break;
                    }
                    message.playerLoadVast = Sdk_Player_LoadVast.decode(reader, reader.uint32());
                    continue;
                case 22:
                    if (tag !== 178) {
                        break;
                    }
                    message.playerSetStaticProgramInfoCallback = Sdk_Player_SetStaticProgramInfoCallback.decode(reader, reader.uint32());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.playerStop = Sdk_Player_Stop.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.playerDestroy = Sdk_Player_Destroy.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.playerSeekToAdBreakEnd = Sdk_Player_SeekToAdBreakEnd.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.playerThumbnailData = Sdk_Player_ThumbnailData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            playerCreate: isSet(object.playerCreate) ? Sdk_Player_Create.fromJSON(object.playerCreate) : undefined,
            playerPlayUrl: isSet(object.playerPlayUrl) ? Sdk_Player_PlayUrl.fromJSON(object.playerPlayUrl) : undefined,
            playerPlay: isSet(object.playerPlay) ? Sdk_Player_Play.fromJSON(object.playerPlay) : undefined,
            playerPause: isSet(object.playerPause) ? Sdk_Player_Pause.fromJSON(object.playerPause) : undefined,
            playerSeek: isSet(object.playerSeek) ? Sdk_Player_Seek.fromJSON(object.playerSeek) : undefined,
            playerSeekForward: isSet(object.playerSeekForward)
                ? Sdk_Player_SeekForward.fromJSON(object.playerSeekForward)
                : undefined,
            playerSeekBackward: isSet(object.playerSeekBackward)
                ? Sdk_Player_SeekBackward.fromJSON(object.playerSeekBackward)
                : undefined,
            playerSetVolume: isSet(object.playerSetVolume)
                ? Sdk_Player_SetVolume.fromJSON(object.playerSetVolume)
                : undefined,
            playerSetRate: isSet(object.playerSetRate) ? Sdk_Player_SetRate.fromJSON(object.playerSetRate) : undefined,
            playerGetAvailableAudioTracks: isSet(object.playerGetAvailableAudioTracks)
                ? Sdk_Player_GetAvailableAudioTracks.fromJSON(object.playerGetAvailableAudioTracks)
                : undefined,
            playerSetAudioTrack: isSet(object.playerSetAudioTrack)
                ? Sdk_Player_SetAudioTrack.fromJSON(object.playerSetAudioTrack)
                : undefined,
            playerSetSubtitlesTrack: isSet(object.playerSetSubtitlesTrack)
                ? Sdk_Player_SetSubtitlesTrack.fromJSON(object.playerSetSubtitlesTrack)
                : undefined,
            playerGetSelectedAudioTrack: isSet(object.playerGetSelectedAudioTrack)
                ? Sdk_Player_GetSelectedAudioTrack.fromJSON(object.playerGetSelectedAudioTrack)
                : undefined,
            playerGetAvailableSubtitlesTracks: isSet(object.playerGetAvailableSubtitlesTracks)
                ? Sdk_Player_GetAvailableSubtitlesTracks.fromJSON(object.playerGetAvailableSubtitlesTracks)
                : undefined,
            playerGetSelectedSubtitlesTrack: isSet(object.playerGetSelectedSubtitlesTrack)
                ? Sdk_Player_GetSelectedSubtitlesTrack.fromJSON(object.playerGetSelectedSubtitlesTrack)
                : undefined,
            playerGetProperties: isSet(object.playerGetProperties)
                ? Sdk_Player_GetProperties.fromJSON(object.playerGetProperties)
                : undefined,
            playerLoadVast: isSet(object.playerLoadVast) ? Sdk_Player_LoadVast.fromJSON(object.playerLoadVast) : undefined,
            playerSetStaticProgramInfoCallback: isSet(object.playerSetStaticProgramInfoCallback)
                ? Sdk_Player_SetStaticProgramInfoCallback.fromJSON(object.playerSetStaticProgramInfoCallback)
                : undefined,
            playerStop: isSet(object.playerStop) ? Sdk_Player_Stop.fromJSON(object.playerStop) : undefined,
            playerDestroy: isSet(object.playerDestroy) ? Sdk_Player_Destroy.fromJSON(object.playerDestroy) : undefined,
            playerSeekToAdBreakEnd: isSet(object.playerSeekToAdBreakEnd)
                ? Sdk_Player_SeekToAdBreakEnd.fromJSON(object.playerSeekToAdBreakEnd)
                : undefined,
            playerThumbnailData: isSet(object.playerThumbnailData)
                ? Sdk_Player_ThumbnailData.fromJSON(object.playerThumbnailData)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.playerCreate !== undefined) {
            obj.playerCreate = Sdk_Player_Create.toJSON(message.playerCreate);
        }
        if (message.playerPlayUrl !== undefined) {
            obj.playerPlayUrl = Sdk_Player_PlayUrl.toJSON(message.playerPlayUrl);
        }
        if (message.playerPlay !== undefined) {
            obj.playerPlay = Sdk_Player_Play.toJSON(message.playerPlay);
        }
        if (message.playerPause !== undefined) {
            obj.playerPause = Sdk_Player_Pause.toJSON(message.playerPause);
        }
        if (message.playerSeek !== undefined) {
            obj.playerSeek = Sdk_Player_Seek.toJSON(message.playerSeek);
        }
        if (message.playerSeekForward !== undefined) {
            obj.playerSeekForward = Sdk_Player_SeekForward.toJSON(message.playerSeekForward);
        }
        if (message.playerSeekBackward !== undefined) {
            obj.playerSeekBackward = Sdk_Player_SeekBackward.toJSON(message.playerSeekBackward);
        }
        if (message.playerSetVolume !== undefined) {
            obj.playerSetVolume = Sdk_Player_SetVolume.toJSON(message.playerSetVolume);
        }
        if (message.playerSetRate !== undefined) {
            obj.playerSetRate = Sdk_Player_SetRate.toJSON(message.playerSetRate);
        }
        if (message.playerGetAvailableAudioTracks !== undefined) {
            obj.playerGetAvailableAudioTracks = Sdk_Player_GetAvailableAudioTracks.toJSON(message.playerGetAvailableAudioTracks);
        }
        if (message.playerSetAudioTrack !== undefined) {
            obj.playerSetAudioTrack = Sdk_Player_SetAudioTrack.toJSON(message.playerSetAudioTrack);
        }
        if (message.playerSetSubtitlesTrack !== undefined) {
            obj.playerSetSubtitlesTrack = Sdk_Player_SetSubtitlesTrack.toJSON(message.playerSetSubtitlesTrack);
        }
        if (message.playerGetSelectedAudioTrack !== undefined) {
            obj.playerGetSelectedAudioTrack = Sdk_Player_GetSelectedAudioTrack.toJSON(message.playerGetSelectedAudioTrack);
        }
        if (message.playerGetAvailableSubtitlesTracks !== undefined) {
            obj.playerGetAvailableSubtitlesTracks = Sdk_Player_GetAvailableSubtitlesTracks.toJSON(message.playerGetAvailableSubtitlesTracks);
        }
        if (message.playerGetSelectedSubtitlesTrack !== undefined) {
            obj.playerGetSelectedSubtitlesTrack = Sdk_Player_GetSelectedSubtitlesTrack.toJSON(message.playerGetSelectedSubtitlesTrack);
        }
        if (message.playerGetProperties !== undefined) {
            obj.playerGetProperties = Sdk_Player_GetProperties.toJSON(message.playerGetProperties);
        }
        if (message.playerLoadVast !== undefined) {
            obj.playerLoadVast = Sdk_Player_LoadVast.toJSON(message.playerLoadVast);
        }
        if (message.playerSetStaticProgramInfoCallback !== undefined) {
            obj.playerSetStaticProgramInfoCallback = Sdk_Player_SetStaticProgramInfoCallback.toJSON(message.playerSetStaticProgramInfoCallback);
        }
        if (message.playerStop !== undefined) {
            obj.playerStop = Sdk_Player_Stop.toJSON(message.playerStop);
        }
        if (message.playerDestroy !== undefined) {
            obj.playerDestroy = Sdk_Player_Destroy.toJSON(message.playerDestroy);
        }
        if (message.playerSeekToAdBreakEnd !== undefined) {
            obj.playerSeekToAdBreakEnd = Sdk_Player_SeekToAdBreakEnd.toJSON(message.playerSeekToAdBreakEnd);
        }
        if (message.playerThumbnailData !== undefined) {
            obj.playerThumbnailData = Sdk_Player_ThumbnailData.toJSON(message.playerThumbnailData);
        }
        return obj;
    },
    create(base) {
        return Sdk_Action.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSdk_Action();
        message.playerCreate = (object.playerCreate !== undefined && object.playerCreate !== null)
            ? Sdk_Player_Create.fromPartial(object.playerCreate)
            : undefined;
        message.playerPlayUrl = (object.playerPlayUrl !== undefined && object.playerPlayUrl !== null)
            ? Sdk_Player_PlayUrl.fromPartial(object.playerPlayUrl)
            : undefined;
        message.playerPlay = (object.playerPlay !== undefined && object.playerPlay !== null)
            ? Sdk_Player_Play.fromPartial(object.playerPlay)
            : undefined;
        message.playerPause = (object.playerPause !== undefined && object.playerPause !== null)
            ? Sdk_Player_Pause.fromPartial(object.playerPause)
            : undefined;
        message.playerSeek = (object.playerSeek !== undefined && object.playerSeek !== null)
            ? Sdk_Player_Seek.fromPartial(object.playerSeek)
            : undefined;
        message.playerSeekForward = (object.playerSeekForward !== undefined && object.playerSeekForward !== null)
            ? Sdk_Player_SeekForward.fromPartial(object.playerSeekForward)
            : undefined;
        message.playerSeekBackward = (object.playerSeekBackward !== undefined && object.playerSeekBackward !== null)
            ? Sdk_Player_SeekBackward.fromPartial(object.playerSeekBackward)
            : undefined;
        message.playerSetVolume = (object.playerSetVolume !== undefined && object.playerSetVolume !== null)
            ? Sdk_Player_SetVolume.fromPartial(object.playerSetVolume)
            : undefined;
        message.playerSetRate = (object.playerSetRate !== undefined && object.playerSetRate !== null)
            ? Sdk_Player_SetRate.fromPartial(object.playerSetRate)
            : undefined;
        message.playerGetAvailableAudioTracks =
            (object.playerGetAvailableAudioTracks !== undefined && object.playerGetAvailableAudioTracks !== null)
                ? Sdk_Player_GetAvailableAudioTracks.fromPartial(object.playerGetAvailableAudioTracks)
                : undefined;
        message.playerSetAudioTrack = (object.playerSetAudioTrack !== undefined && object.playerSetAudioTrack !== null)
            ? Sdk_Player_SetAudioTrack.fromPartial(object.playerSetAudioTrack)
            : undefined;
        message.playerSetSubtitlesTrack =
            (object.playerSetSubtitlesTrack !== undefined && object.playerSetSubtitlesTrack !== null)
                ? Sdk_Player_SetSubtitlesTrack.fromPartial(object.playerSetSubtitlesTrack)
                : undefined;
        message.playerGetSelectedAudioTrack =
            (object.playerGetSelectedAudioTrack !== undefined && object.playerGetSelectedAudioTrack !== null)
                ? Sdk_Player_GetSelectedAudioTrack.fromPartial(object.playerGetSelectedAudioTrack)
                : undefined;
        message.playerGetAvailableSubtitlesTracks =
            (object.playerGetAvailableSubtitlesTracks !== undefined && object.playerGetAvailableSubtitlesTracks !== null)
                ? Sdk_Player_GetAvailableSubtitlesTracks.fromPartial(object.playerGetAvailableSubtitlesTracks)
                : undefined;
        message.playerGetSelectedSubtitlesTrack =
            (object.playerGetSelectedSubtitlesTrack !== undefined && object.playerGetSelectedSubtitlesTrack !== null)
                ? Sdk_Player_GetSelectedSubtitlesTrack.fromPartial(object.playerGetSelectedSubtitlesTrack)
                : undefined;
        message.playerGetProperties = (object.playerGetProperties !== undefined && object.playerGetProperties !== null)
            ? Sdk_Player_GetProperties.fromPartial(object.playerGetProperties)
            : undefined;
        message.playerLoadVast = (object.playerLoadVast !== undefined && object.playerLoadVast !== null)
            ? Sdk_Player_LoadVast.fromPartial(object.playerLoadVast)
            : undefined;
        message.playerSetStaticProgramInfoCallback =
            (object.playerSetStaticProgramInfoCallback !== undefined && object.playerSetStaticProgramInfoCallback !== null)
                ? Sdk_Player_SetStaticProgramInfoCallback.fromPartial(object.playerSetStaticProgramInfoCallback)
                : undefined;
        message.playerStop = (object.playerStop !== undefined && object.playerStop !== null)
            ? Sdk_Player_Stop.fromPartial(object.playerStop)
            : undefined;
        message.playerDestroy = (object.playerDestroy !== undefined && object.playerDestroy !== null)
            ? Sdk_Player_Destroy.fromPartial(object.playerDestroy)
            : undefined;
        message.playerSeekToAdBreakEnd =
            (object.playerSeekToAdBreakEnd !== undefined && object.playerSeekToAdBreakEnd !== null)
                ? Sdk_Player_SeekToAdBreakEnd.fromPartial(object.playerSeekToAdBreakEnd)
                : undefined;
        message.playerThumbnailData = (object.playerThumbnailData !== undefined && object.playerThumbnailData !== null)
            ? Sdk_Player_ThumbnailData.fromPartial(object.playerThumbnailData)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
